import { CSSResultGroup, html, nothing, TemplateResult } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { paymentMethodSelectable } from 'components/ordering/checkout/payment-methods/payment-methods.style.js'
import {
  CSCMolliePaymentMethod,
  PaymentMethodState
} from 'components/ordering/checkout/payment-methods/methods/payment-method.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { dependencyContainer } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import {
  APPLE_PAY_AVAILABILITY_CHECKER,
  ApplePayAvailabilityChecker
} from 'components/ordering/checkout/payment-methods/methods/mollie/apple-pay/apple-pay-availability-checker.js'
import './apple-pay-session.js'
import {
  StartMolliePaymentPayload,
} from 'components/ordering/checkout/payment-methods/payment-backend/start-payment-api.js'
import { MollieApplePayPayload } from '@cloudsuite/cs-payment-defs/dist/index.js'


export interface TrydentMollieApplePayData {
  id: string
  description: string
  image_url: string
}


@customElement('csc-mollie-apple-pay')
export class CSCMollieApplePay extends CSCMolliePaymentMethod {
  static override styles: CSSResultGroup = [hostStyle, paymentMethodSelectable]

  @state() protected readonly paymentMethodId: string
  @state() protected readonly customDescription: string | null
  @state() protected state: PaymentMethodState

  @state() private readonly description: string
  @state() private readonly imageUrl: string


  constructor({ id, description, image_url }: TrydentMollieApplePayData, state: PaymentMethodState, customDescription: string | null) {
    super()

    this.paymentMethodId = id
    this.customDescription = customDescription
    this.state = state

    this.description = description
    this.imageUrl = image_url
  }

  protected renderPaymentMethodContent = (): TemplateResult => {
    const applePayChecker = dependencyContainer.getDependency(APPLE_PAY_AVAILABILITY_CHECKER) as ApplePayAvailabilityChecker
    const isAvailable = applePayChecker.canMakeApplePayments()

    if (!isAvailable) {
      return nothing as unknown as TemplateResult
    }

    return html`
      <div class="selectable-content">
        <cse-image
          source="${this.imageUrl}"
          alt="${this.description}"
          width="55"
          height="41"
        >
        </cse-image>
        <cse-text>${this.description}</cse-text>
      </div>
    `
  }

  protected getPayload = async (): Promise<StartMolliePaymentPayload> => {
    return new MollieApplePayPayload()
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'csc-mollie-apple-pay': CSCMollieApplePay,
  }
}
